<template>
  <v-row class="align-center">
    <v-col cols="12" class="pa-0 mb-1" v-for="(item, i) in leads" :key="'item'+i">
      <LeadMaster :item="item" :i="i" @details="details" @rate="rate" @message="message"
      @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" @sendtocrm="sendtocrm" @deleteFromNinja="deleteFromNinja" />
    </v-col>
    <v-col cols="12" class="py-0" DETAILS>
      <v-dialog
        v-model="dialog"
        scrollable  
        persistent :overlay="false"
        max-width="900px"
        transition="dialog-transition"
      >
        <v-card>
          <v-toolbar color="white" flat dense>
            <div :class="`${arabic?'arFont':'enFont'}`">{{  i18n["order_details"] }}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text small :class="`${arabic?'arFont':'enFont'}`" @click="dialog = false">{{ i18n["close"] }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text v-if="lead">
            <div :class="`${arabic?'arFont':'enFont'} mb-1`" style="font-weight:bold;">{{ i18n["basic_info"] }}</div>
            <LeadMaster :item="lead" :embed="true" @details="details"
            @clipboardSuccessHandler="clipboardSuccessHandler" @clipboardErrorHandler="clipboardErrorHandler" />
            <div :class="`${arabic?'arFont':'enFont'} my-1`" style="font-weight:bold;">{{ i18n["follow_up_order_status"] }}</div>
            <Timeline :updates="lead.updates" />
            <div :class="`${arabic?'arFont':'enFont'} my-1`" style="font-weight:bold;">{{ i18n["follow_up_calls"] }}</div>
            <TimelineCalls :updates="lead.calls" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :class="`${arabic?'arFont':'enFont'}`" @click="dialog = false">{{ i18n["close"] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" class="py-0" RATE>
      <v-dialog
        v-model="dialog2"
        scrollable  
        persistent :overlay="false"
        max-width="700px"
        transition="dialog-transition"
      >
        <v-card>
          <v-toolbar color="white" flat dense>
            <div :class="`${arabic?'arFont':'enFont'}`">{{ i18n["order_id_order_rating"] }}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text small :class="`${arabic?'arFont':'enFont'}`" @click="dialog2 = false">{{ i18n["close"] }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="text-center">
            <v-rating
              v-model="rating"
              background-color="secondary lighten-1"
              color="secondary"
              half-increments
              hover
              size="64"
            >
            </v-rating>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :class="`${arabic?'arFont':'enFont'}`" @click="dialog = false">{{ i18n["send"] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" class="py-0" MESSAGE>
      <v-dialog
        v-model="dialog3"
        scrollable  
        persistent :overlay="false"
        max-width="700px"
        transition="dialog-transition"
      >
        <v-card>
          <v-toolbar color="white" flat dense>
            <div :class="`${arabic?'arFont':'enFont'}`">{{ i18n["order_number_send_message_about_order"] }}</div>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text small :class="`${arabic?'arFont':'enFont'}`" @click="dialog3 = false">{{ i18n['close'] }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="text-center">
            <v-textarea
              :class="`${arabic?'arFont':'enFont'}`"
              label="الرسالة"
              filled
              hide-details
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text :class="`${arabic?'arFont':'enFont'}`" @click="dialog = false">{{ i18n['send'] }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import LeadMaster from './LeadMaster'
import Order from './Order'
import Timeline from './Timeline'
import TimelineCalls from './TimelineCalls'
export default {
  props:["leads"],
  components: { LeadMaster, Order, Timeline, TimelineCalls },
  data(){
    return {
      dialog:false,
      dialog2:false,
      dialog3:false,
      lead:null,
      rating:0,
      
    }
  },
  methods:{
    clipboardSuccessHandler ({ value, event }){
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    async details(i){
      this.lead = this.leads[i]
      this.lead = await this.$store.dispatch('getResource', {resource:'/lead-master/' + this.lead.uuid, page:``})
      // console.log(this.lead)
      this.dialog = true
    },
    rate(i){
      this.lead = this.leads[i]
      this.dialog2 = true
    },
    message(i){
      this.lead = this.leads[i]
      this.dialog3 = true
    },
    async sendtocrm(i){
      this.lead = this.leads[i]
      let a = await this.$store.dispatch('postResource', {resource:'/sync-lead-crm', value:this.lead})
      // console.log(a)
    },
    async deleteFromNinja(i){
      this.lead = this.leads[i]
      let a = await this.$store.dispatch('deleteResource', {resource:'/leads/' + this.lead.id })
      // console.log(a)
    }
  },
  computed:{
    
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>